<template>
  <div class="setup-cpn"
       v-loading="loading">
    <div class="remain-title"
         v-if="remain">
      {{remain}}
    </div>
    <div style="width: 90%; padding: 0 20px;height: 48%">
      <p style="font-size: 20px; font-weight: 400">我的充值记录</p>
      <el-table :data="chargeTableData"
                height="calc(100% - 70px)"
                stripe
                border
                fit>
        <el-table-column prop="ts"
                         label="时间"
                         align="center">
        </el-table-column>
        <el-table-column prop="rights"
                         label="权益"
                         align="center">
        </el-table-column>
        <el-table-column prop="expire_time"
                         label="有效期"
                         align="center">
        </el-table-column>
        <el-table-column prop="source"
                         label="来源"
                         align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="width: 90%; padding: 0 20px;height: 48%">
      <p style="font-size: 20px; font-weight: 400">我的提问记录</p>
      <el-table :data="tableData"
                height="calc(100% - 70px)"
                stripe
                border
                fit>
        <el-table-column prop="ask_time"
                         label="时间">
        </el-table-column>
        <el-table-column prop="question"
                         label="问题内容">
        </el-table-column>
        <el-table-column prop="time_cost"
                         label="回答时间"
                         align="center"
                         :formatter="(row, column, cellValue) => {return cellValue + '秒'}">
        </el-table-column>
        <el-table-column prop="conv_name"
                         label="对话名称">
        </el-table-column>
        <el-table-column prop="cost"
                         align="center"
                         label="扣费">
        </el-table-column>
        <el-table-column prop="question_id"
                         align="center"
                         label="question_id">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>


<script>
import { getHistoryCost, postHistoryChargeList } from '@/api/public.js'
export default {
  name: 'Setup',
  data() {
    return {
      loading: false,
      remain: '',
      tableData: [],
      chargeTableData: [],
    }
  },
  props: {},
  computed: {},
  methods: {
    formatDateString(input) {
      // 如果输入是'长期有效'，直接返回
      if (input === '长期有效') {
        return input
      }

      try {
        // 尝试将输入解析为日期
        const date = new Date(input)

        // 检查是否是有效日期
        if (isNaN(date.getTime())) {
          return input
        }

        // 格式化为 yyyy-mm-dd
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
      } catch (error) {
        // 如果解析失败，返回原字符串
        return input
      }
    },
  },
  created() {},
  mounted() {},
  watch: {
    '$store.state.user.chatId': {
      handler(newVal) {
        if (newVal == 'setup') {
          this.loading = true
          postHistoryChargeList().then((res) => {
            if (res.status == 'ok') {
              const result = res.result
              const charge_history = result.charge_history
              this.chargeTableData = charge_history.map((item) => {
                const temp = {}
                temp.ts = item.charge_time
                temp.rights = item.rights
                temp.source = item.source
                temp.expire_time = this.formatDateString(item.expire_time)
                return temp
              })
            }
          })
          getHistoryCost()
            .then((res) => {
              this.loading = false
              if (res.status == 'ok') {
                const result = res.result
                this.remain = result.user_quota_text
                this.tableData = result.data
              }
            })
            .catch((err) => {
              this.loading = false
            })
        }
      },
    },
  },
}
</script>

<style lang="less">
.setup-cpn {
  height: calc(100%);
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  background-color: #fff;
  .remain-title {
    margin-top: 20px;
    background-color: #364df5;
    width: 50%;
    padding: 10px 20%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: white;
    letter-spacing: 2px;
    border-radius: 5px;
  }
  .el-table thead {
    color: #000;
  }
  .el-table tr {
    background-color: #f9f9f9;
  }
  .el-table tr:nth-child(even) {
    background-color: #ffffff;
  }
  .el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    background-color: #ffffff;
  }
  .el-table .el-table__cell {
    padding: 5px 0;
  }
  .el-table th.el-table__cell {
    background-color: #e9ecf1;
    padding: 5px;
    font-size: 14px;
  }
  .el-table--enable-row-transition .el-table__body td.el-table__cell {
    border: none;
  }
}
</style>
